var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { addCsrfTokenToRequestHeader } from "../utils/api";
import { DESTINATION_TAG } from "../features/setup-delivery/models/setupDeliveryModels";
import { FILE_BROWSER_TAG } from "../features/file-browser/models/fileBrowserModels";
import { setCurrentUser, setIsSessionExpired, setPulseAccountId, setSessionExpiredReason } from "../features/auth/authSlice";
import { SESSION_UNAUTHORIZED_MESSAGE } from "../features/auth/models/authModels";
export const API_PORT = "7777";
export const API_BASE_URL = process.env.NODE_ENV === "test"
    ? `http://localhost:${API_PORT}/api`
    : "/api";
const baseQuery = fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: (headers, { type }) => addCsrfTokenToRequestHeader(headers, type)
});
export const baseQueryWithErrorHandling = (args, api, extraOptions = {}) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const result = yield baseQuery(args, api, extraOptions);
    if (((_a = result.error) === null || _a === void 0 ? void 0 : _a.status) === 401) {
        api.dispatch(setIsSessionExpired(true));
        api.dispatch(setSessionExpiredReason(SESSION_UNAUTHORIZED_MESSAGE));
        api.dispatch(setCurrentUser(null));
        api.dispatch(setPulseAccountId(null));
    }
    return result;
});
export const api = createApi({
    reducerPath: 'api',
    baseQuery: baseQueryWithErrorHandling,
    tagTypes: [FILE_BROWSER_TAG, DESTINATION_TAG],
    endpoints: () => ({})
});
